export default "__VITE_ASSET__a21fc6c9__"